<template>
    <!--Waiting List Clients Main Container-->
    <div class="waiting-list-clients">
        <!--Heading-->
        <h3>{{ $ml.get("waitingListClients.title") }}</h3>
        <!--Waiting List Clients Wrapper-->
        <div class="section-wrap">
            <div class="wlist-clients-wrap show-clients" v-if="!loading">
                <h5>Waitlist ({{ clients.length }})</h5>
                <div class="wlist-clients-content " v-if="clients.length > 0">
                    <!--Clients Waiting List-->
                    <div class="client section-wrap" v-for="client in clients" :key="client.index">
                        <div class="client-info">
                            <p>
                                <span>{{ client.first_name }} {{ client.last_name }}</span> is on your waitlist for a
                                '<span>{{ client.service_names[0] }}</span>' appointment
                                <span>
                                    ({{ getFormattedDate(client.from_date, "MMM DD, YYYY") }}–{{
                                    getFormattedDate(client.to_date, "MMM DD, YYYY")
                                    }}) </span>.
                            </p>
                            <p>Client will be notified by <span>{{ client.notification_method }}</span> as soon as a spot becomes available.</p>
                        </div>
                        <div class="client-actions">
                            <button class="remove primary-btn extra-small extra mobile"
                                @click="getCurrentClient(client)" type="button" data-toggle="modal"
                                data-target="#removeClient">
                                Remove
                            </button>
                        </div>
                    </div>
                </div>
                <div class="wlist-empty section-wrap" v-if="clients.length === 0">
                    <p>You don't have any clients on the waiting list.</p>
                </div>
                <!--Back to Dashboard-->
                <div class="back-btn-wrap">
                    <router-link class="primary-btn extra-small mobile" :to="{ path: '/app/waiting-list/dashboard' }">
                        {{ $ml.get("general.goBack") }}
                    </router-link>
                </div>
            </div>
            <main-loader v-if="loading"></main-loader>
        </div>
        <!--Modal-->
        <waiting-list-modal id="removeClient" title="Remove Client"
            :p1="`Are you sure you want to remove <strong>${clientName}</strong> from the Waitlist?`"
            :removeClient="true" buttonText="Yes" buttonText2="Close" @remove-client="removeClientFromStylistWaitlist">
        </waiting-list-modal>
    </div>
</template>

<script>
import WaitingListModal from "./parts/waiting_list_modal.vue";
import api from "../../../services/api_endpoints";
import moment from "moment";
import MainLoader from "../general-components/main_loader.vue";
import messages from "../../../services/messages";

export default {
    data() {
        return {
            clients: [],
            currentClient: {},
            offset: 0,
            take: 10,
            loading: false,
            clientName: [],
        };
    },
    computed: {},
    mounted() {
        this.getWaitlistClients();
    },
    components: {
        WaitingListModal,
        MainLoader,
    },
    methods: {
        getCurrentClient(client) {
            this.currentClient = client;
            this.clientName = `${client.first_name} ${client.last_name}`
        },
        getWaitlistClients() {
            this.loading = true;

            this.$http
                .get(api.actions.get_waitlist_clients + "?take=" + this.take + "&offset=" + this.offset)
                .then((response) => {
                    if (response.data.error == true) {
                        return;
                    }

                    this.clients = response.body.clients;
                    this.loading = false;
                });
            return;
        },
        getFormattedDate(date, format) {
            return moment(date).format(format);
        },
        removeClientFromStylistWaitlist() {
            let data = {
                client_id: this.currentClient.client_id,
            };

            this.$http.post(api.actions.remove_client_from_stylist_waitlist, data).then((response) => {

                if (response.data.error == true) {
                    return;
                }

                this.getWaitlistClients();
                messages.successMessage(messages.GLOBAL_MESSAGES.CLIENT_REMOVED_FROM_WAITING_LIST);
            });
            return;
        },
    },
};
</script>
